<template>
    <form ref="recurring_new">
        <div class="card__header">
            <p class="card__title">Information</p>
        </div>
        <div class="card__content">
            <div class="form">
                <div class="form__field" v-if="canEditDate()">
                    <label class="form__label">Start date</label>
                    <input type="text" class="form__control form-field required datepicker" placeholder="jj/mm/yyyy" v-model="$parent.date">
                    <div class="form__icon">
                        <icon-calendar></icon-calendar>
                    </div>
                </div>
                <div class="form__field">
                  <p class="form__label">Frequency</p>
                  <div class="form__control radio radio--landscape">
                        <span class="radio__item radio__item--required">
                            <input type="radio" name="every_other_week" id="weekly" value="0"
                            v-model="$parent.every_other_week" class="radio__control required" checked>
                            <label for="weekly" class="radio__label">Weekly</label>
                        </span>
                        <span class="radio__item">
                            <input type="radio" name="every_other_week" id="fortnightly" value="1"
                            v-model="$parent.every_other_week" class="radio__control">
                            <label for="fortnightly" class="radio__label">Fortnightly</label>
                        </span>
                  </div>
                </div>
                <div class="form__field">
                    <p class="form__label">Delivery method</p>
                    <div class="form__control radio radio--landscape">
                        <span class="radio__item radio__item--required">
                            <input type="radio" name="delivery-method" id="recurring-drop-off" value="DROP_OFF"
                            v-model="$parent.method" class="radio__control required">
                            <label for="recurring-drop-off" class="radio__label">Drop-off</label>
                        </span>
                        <span class="radio__item">
                            <input type="radio" name="delivery-method" id="recurring-to-hand" value="HAND_TO_HAND"
                            v-model="$parent.method" class="radio__control">
                            <label for="recurring-to-hand" class="radio__label">Hand-to-hand</label>
                        </span>
                    </div>
                    <p class="form__notice mt-1">If you select the drop-off option you will receive a complimentary Blutobag with your first delivery. Reusable and waterproof, it will keep your bread in the best possible conditions.</p>
                </div>
                <div class="form__field">
                    <h3 class="form__label">Days</h3>
                    <p class="form__notice">Click on the days you’d like to be treated to our delicious products. You will then be able to select your delivery time and items.</p>
                    <div class="orderDays mt-2">
                        <div class="orderDay" v-for="_day in $data._days">
                            <input type="checkbox" class="orderDay__input" v-on:change="setDayInCart($event, _day.long)"
                                :disabled="_day.long === 'MONDAY' || _day.long === 'TUESDAY'"
                                :checked="(_day.long in $parent.cart)" v-if="canOrderThisDay(_day)"/>
                            <span class="orderDay__day">{{ _day.short }}</span>
                        </div>
                    </div>
                    <p class="form__notice form__notice--error js-order-error mt-2" style="display: none;">Please select at least 1 day</p>
                </div>
                <div class="form__field" v-if="Object.keys($parent.extraProductsByDay).length">
                    <div class="alert alert--info alert--notice">
                        <p class="alert__title">Please note that there are additional items in some of your deliveries. If you remove the corresponding day from your setup these items will be removed.</p>
                        <div class="alert__subtitle">
                            <p v-for="(extraProducts, date) in $parent.extraProductsByDay">
                                {{ date | dateToDay }} {{ date | dateFormat }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card__actions">
            <button type="button" class="button button--md button--secondary" v-on:click="nextStep()">Next</button>
        </div>
    </form>
</template>

<script>
export default {
    mounted() {
        let closingTime = new Date();
        closingTime.setHours(window.config.closing_time);

        let now = new Date();
        //now.setHours(now.getUTCHours());

        let startDate = new Date();
        startDate.setDate(startDate.getDate() + 2);

        // Allow order for tomorrow until specific hours, or +2 days
        if (now.getHours() >= closingTime.getHours()) {
            startDate.setDate(startDate.getDate() + 2);
        }

        $('.datepicker').datepicker({
            format: 'dd/mm/yyyy',
            weekStart: 1,
            startDate: startDate,
            autoclose: true,
            halfDays: this.$parent.halfDays,
            beforeShowDay: function(date) {
                let dayNumber = date.getDay();

                // Can't order monday and tuesday
                if (dayNumber === 1 || dayNumber === 2) {
                    return false;
                }

                // closing dates
                let startHoliday = new Date('2024-11-30 00:00:00'); // start date
                let endHoliday = new Date('2025-12-31 00:00:00'); // resume date
                if (date >= startHoliday && date < endHoliday) {
                    return false;
                }

                return !!this.halfDays.find(e => {
                  let startAt = new Date(e.pivot.start_at);
                  startAt.setHours(0);
                  startAt.setMinutes(0);
                  startAt.setSeconds(0);

                  if (e.pivot.end_at) {
                    let endAt = new Date(e.pivot.end_at);
                    endAt.setHours(0);
                    endAt.setMinutes(0);
                    endAt.setSeconds(0);
                    return e.dayNumber === dayNumber && date >= startAt && date <= endAt;
                  }

                  return e.dayNumber === dayNumber && date >= startAt;
                });
            }
        }).on('changeDate', (e) => {
            this.$parent.date = e.target.value;
        });
    },

    methods: {
        canEditDate() {
            if (!this.$root.orders.recurring) {
                return true;
            }

            const now = new Date();
            const orderDate = new Date(this.$root.orders.recurring.start_date);

            return now < orderDate;
        },

        canOrderThisDay(day) {
            return !!this.$parent.halfDays.find(e => e.day === day.long);
        },

        setDayInCart(event, day) {
            var $el = $(event.target);

            if ($el.is(':checked')) {
                Vue.set(this.$parent.cart, day, {});
            } else {
                delete this.$parent.cart[day];
            }

            // Reorder cart by day
            var cart = {};
            Object.keys(this.$parent.cart).sort((a, b) => {
                return this.$data._daysOrder[a] - this.$data._daysOrder[b];
            }).forEach((key) => {
                cart[key] = this.$parent.cart[key];
            });

            $('.js-order-error').fadeOut();
            Vue.set(this.$parent, 'cart', cart);
        },

        nextStep() {
            if (!$(this.$refs.recurring_new).valid()) return false;

            $('.js-order-error').fadeOut();

            if (Object.keys(this.$parent.cart).length > 0) {
                this.$parent.step = 'BASKET';
            } else {
                $('.js-order-error').fadeIn();
                return false;
            }
        }
    }
}
</script>
